<template>
  <div id="app"
       class="app">
    <transition name="fade"
                mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import { Common } from 'js/class/Common'
// import { mapState, mapMutations } from 'vuex'
import topbar from 'topbar'

export default {
  name: 'app',
  components: {
    remote: {
      render(createEle) {
        return createEle('script', {
          attrs: {
            type: 'text/javascript',
            src: this.src,
          },
        });
      },
      props: {
        src: {
          type: String,
          required: true,
        },
      },
    },
  },
  data(){
    return {
      src:'',
    }
  },
  created () {
    // this.loadLang()
    // this.src= process.env.NODE_ENV === 'production'? `/v/fishbone/lib/jtopo-0.4.8.js` : `/fishbone/lib/jtopo-0.4.8.js`
    // this.setPath()
  },
  mounted () {
    topbar.config({
      barColors    : {
        // '0'        : 'rgba(255,  255, 255, .7)',
        // '.3'       : 'rgba(255,  245, 245, .7)',
        // '1.0'      : 'rgba(255, 235,  235,  .7)'
        '0'        : 'rgba(255, 69, 0, 1)',
        '.3'       : 'rgba(238, 64, 0, 1)',
        '1.0'      : 'rgba(205, 55, 0,  1)'
      },
      shadowColor  : 'rgba(139, 37, 0, .8)',
    })


    let showLoading = () => {
      let html =
        `<div id="global-loading" class="el-loading-mask" style="background-color: rgba(0, 0, 0, 0.5);">
          <div class="el-loading-spinner"><i class="el-icon-loading"></i>
            <p class="el-loading-text">加载中...</p>
          </div>
        </div>`
      let not_show = document.querySelectorAll('#global-loading').length === 0
      if (not_show) {
        document.body.insertAdjacentHTML( 'beforeend', html ); // The position parameter beforeend will add inside the element, after its last child.
      }
    }

    let hideLoading = () => {
      let loading = document.querySelectorAll('#global-loading')[0]
      loading && document.body.removeChild(loading)
    }

    // 使用一个window对象的setter 来监测请求的状态，
    // 因为window.onmessage 注册在了iframePage 页面，无法全局调用显示topbar

    window.fetchDispather = {
      set fetching (value) {
        if (value.flag === 'fetching') {
          if (value.data.pending) {
            topbar.show()
            // showLoading()
          } else {
            topbar.hide()
            // hideLoading()
          }
        }
      }
    }
  },
  // computed: {
  //   ...mapState('permission', ['menuList'])
  // },
  methods: {
    /**
     * @author: POPE
     * @description: 加载语言包
     * @param {type}
     * @return:
     */
    async loadLang () {
      // debugger
      // let version = await Lang.getInstance().getLangVersion()
      let enName = 'en_16'
      let zhName = 'zh_16'
      let zhLang = require(`locale/lang/${zhName}.json`)
      let enLang = require(`locale/lang/${enName}.json`)
      this.$i18n.mergeLocaleMessage('en', enLang)
      this.$i18n.mergeLocaleMessage('zh', zhLang)
    },
    /**
     * @author: POPE
     * @description: 设置需要打开的路径
     * @param {type}
     * @return:
     */
    setPath () {
      // debugger
      let hash = window.location.hash
      let path = hash.substr(1)
      if (path.includes('?')) {
        path = path.split('?')[0]
      }
      if (path !== '/login') {
        let param = Common.getInstance().getURLParameter()
        this.setOpenPath(path)
        this.setDetailParam(param)
      }
    },
    // ...mapMutations('tabs', ['setOpenPath', 'setDetailParam'])
  }
}
</script>

<style lang="scss">
@import 'assets/styles/theme/scss/base.scss';
</style>